import { useState } from 'react';
import { AccountStatusCounts } from 'vopay';
import { api } from '@/services/api.config';

export default function useFetchPartnerAccountStatusSummary() {
  const [fetching, setFetching] = useState(false);
  const [numTotalAccounts, setNumTotalAccounts] = useState(0);
  // Partial only until the response lands; every status is present once it has.
  const [statusCounts, setStatusCounts] = useState<Partial<AccountStatusCounts>>({});

  async function fetchPartnerAccountStatusSummary() {
    try {
      setFetching(true);
      const res = await api.fetchPartnerAccountStatusSummary();

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      setNumTotalAccounts(res.TotalAccounts);
      setStatusCounts(res.StatusCounts);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, numTotalAccounts, statusCounts, fetchPartnerAccountStatusSummary };
}
